/**
 * 商品品名管理
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/3/8      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


 import React,{Fragment, PureComponent} from "react"
 import Lang from "@components/Lang/Lang";
 import {Form,Input,Select,Modal,message} from 'antd'
 import PropTypes from 'prop-types';
 import './index.less'
 import FormFormat from '@/components/FormFormat/FormFormat';
 import dayjs from 'dayjs';


 
 class CertificateForm extends PureComponent {
    static propTypes = {
        options: PropTypes.array.isRequired,
    }
    static defaultProps = {

    };

     constructor(props) {
         super(props)
        //  console.log(props)
         this.state = {
            formVisible:false,
            options:this.props.options,
            fromInitialValues:{
                attachment:[]
            }
         }
     }

     formRef = React.createRef();
 
 
     getData = () =>{
        var that = this;
        var id = this.props.id;
        if(id){
            $.ajax({
                url: '/service/mg/certificate/query-detail',
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify({
                    id:id
                }),
                success: (res) => {
                    const {success,valid,model}= res;
                    let options = that.state.options;
                    if (res.success && res.valid) {
                        var fromInitialValues = model|| {}
                        fromInitialValues.categoryList = model.categoryList.map(item => {
                            return {
                                value:item.categoryId,
                                label:item.categoryName
                            }
                        });
    
                        fromInitialValues.effectiveTime = [
                            dayjs(model.effectiveBeginTime),
                            dayjs(model.effectiveEndTime),
                        ]
                        that.setState({
                            options:options,
                            fromInitialValues:fromInitialValues
                        },() => {
                            console.log(that.state)
                        })
                    }
                },
                error: () => {
                    let data = {
                        loading: false,
                    };
                    this.setState(data);
                },
            });
        }

     }

     handleCancel = () => {

        // this.onRefFormFormat.handleReset()
        // this.onRefFormFormat.handleReset();
        this.setState({
            formVisible:false
        },() => {

        })
     }

     async handleOk () {
        let that = this;
        const res = await this.onRefFormFormat.handleOK();



        if(res&&res.success){
            const values = res.data;
            console.log(values)
            let attachment = []
            var postData = {
                code:values.code,
                name:values.name,
                remark:values.remark
            }

            postData.effectiveBeginTime = dayjs(values.effectiveTime[0]).valueOf().toString();
            postData.effectiveEndTime = dayjs(values.effectiveTime[1]).valueOf().toString();
            postData.attachment = values.attachment
            postData.categoryList = values.categoryList.map(item => {
                return {
                    categoryId:item.value,
                    categoryName:item.label,
                }
            })

// effectiveTime
            if(values.attachment){
                attachment = values.attachment.map((item,index) => {
                    item.groupCode = 'SALE_GOODS_CERTIFICATE';
                    return item;
                })
            }

            if ((attachment.length > 5)) {
                message.warning(Lang({id:'ZuiDuoZhiNengShangChuan5GeWenJian', default:'最多只能上传5个文件'}))
                return
            }

            postData.attachment = attachment||[];

            var url = ' /service/mg/certificate/add';
            if(this.props.id){
                postData.id = this.props.id;
                url = ' /service/mg/certificate/update';
            }

            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(postData),
                success: (res) => {
                    if (res.success && res.valid) {
                        message.success(Lang({id:'BaoCunChengGong', default:'保存成功'}));
                        this.props.load();
                        this.setState({
                            formVisible:false,
                        })
                    }else{
                        message.warning(res.message);
                    }
                },
                error: (res) => {
                    let data = {
                        loading: false,
                    };
                    that.setState(data);
                    message.warning(res.message);
                },
            });

            // this.props.saveFormValue(values);
        }
        // this.setState({
        //     formVisible:false
        // })
     }

     reset = () => {
        this.onRefForm().resetFields()
     }

     handleEdit() {

        this.setState({
            formVisible:true,
            options:this.props.options
        },() => {
            this.getData();
        })






     }


     componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }

    }

     componentDidMount() {
         this.getData()
     }

     onRefForm = (ref) =>  this.onRefFormFormat = ref;

     render() {
        var {formVisible,options,fromInitialValues} = this.state;
        // console.log('formVisible',formVisible)
        // console.log('fromInitialValues')
        // console.log(fromInitialValues)
        // console.log(options)
        var data = fromInitialValues
        var title = this.props.id?(
            <Lang id="BianJiZhengShu">编辑证书</Lang>
        ):<Lang id="XinZengZhengShu">新增证书</Lang>

        return (
            <div style={{display:'inline-block'}}>
                {formVisible?
                    <Modal 
                    open={formVisible} 
                    title={title} 
                    closable={false}
                    okText={Lang({id:'QueDing', default:'确定'})}
                    cancelText={Lang({id:'QuXiao', default:'取消'})}
                    onCancel={this.handleCancel}
                    onOk={this.handleOk.bind(this)}
                >
                    <FormFormat
                        onRef={this.onRefForm}
                        options={options}
                        formLayout={'vertical'}
                        initialValues={data}
                    >
                    </FormFormat>
                </Modal>:null
                }
                
                <span onClick={(e) => {
                    this.handleEdit()
                }}>
                    {this.props.children}
                </span>

            </div>


        )
     }
 }
 
 export default CertificateForm
 